import { m } from 'motion/react';
import { type FC } from 'react';

import ProductTypeContainer from '@/lib/UserProfile/components/ProductTypeContainer';
import { NoodleProductTypes } from '@/typings/graphql-models';

import type { ThisProduct, ThisProductType } from '../CreatorBySlug';

import s from './Bytes.module.scss';

const Bytes: FC<{
  productTypes: ThisProductType[];
  allHandbooks: ThisProduct[];
  creatorSlug: string;
  canEdit: boolean;
}> = ({ productTypes, allHandbooks, creatorSlug, canEdit }) => (
  <div className={s.bytes}>
    {productTypes
      .filter((type) => type.noodleProductType === NoodleProductTypes.Handbook)
      .map((type, index) => {
        const bytes = allHandbooks.filter((handbook) => handbook.productTypes?.[0]?.title === type.title);
        if (bytes.length === 0) return null;
        return (
          <m.div
            key={type.title}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 * (index + 1), type: 'spring' }}
          >
            <ProductTypeContainer type={type} bytes={bytes} creatorSlug={creatorSlug} canEdit={canEdit} />
          </m.div>
        );
      })}
  </div>
);

export default Bytes;
